import { initializeApp } from 'firebase/app';
import serviceAccountStageJson from './telly-stage.firebaseapp.com.json';
import serviceAccountProductionJson from './telly.firebaseapp.com.json';

const firebaseConfig = (process.env.NODE_ENV === 'production' ? serviceAccountProductionJson : serviceAccountStageJson);

const app = initializeApp(firebaseConfig);

export default app;
